import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

const options = [
  { label: "Less than 10", value: "less-than-10" },
  { label: "11–100", value: "11-100" },
  { label: "101 or more", value: "101-or-more" },
];

const optionsCustomer = [
  { label: "0", value: "0" },
  { label: "1-10", value: "1-10" },
  { label: "11-100", value: "11-100" },
  { label: "More than 100", value: "More than 100" },
];

const BusinessDetails = ({ inputs, setInputs, loading, handleSubmit, onBack }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [isOpenCustomer, setIsOpenCustomer] = useState(false);
  const navigate = useNavigate();

  return (
    <div className="flex items-center justify-center mt-4">
      <div className="container-main" style={{ background: "white" }}>
        <div className="container !mt-0" style={{ background: "white" }}>
          <div className="">
            <div className="text-center">
              <h1 className="text-[30px] font-medium">
                Scale Your AI Solutions
              </h1>
              <p className="mt-4">
                Help us understand your team's needs for optimal AI integration
              </p>
            </div>

            <div className="mt-8 max-w-[420px] mx-auto">
              <form onSubmit={handleSubmit} className="loginForm">
                <div className="mb-4 !text-left">
                  <div className="relative w-full">
                    <div
                      onClick={() => setIsOpen(!isOpen)}
                      className="border !border-[#D9D9D9] px-2 py-[12px] rounded-md bg-white cursor-pointer"
                    >
                      {inputs.team_size || "Select team size"}
                    </div>
                    {isOpen && (
                      <div className="absolute z-10 mt-1 w-full bg-white border !border-[#D9D9D9] rounded-md shadow-md">
                        {options.map((option, index) => (
                          <div
                            key={index}
                            onClick={() => {
                              setInputs({
                                ...inputs,
                                team_size: option.value,
                              });
                              setIsOpen(false);
                            }}
                            className={` ${inputs.team_size === option.value &&
                              "bg-[#F5F5F5]"
                              } px-4 py-2 hover:bg-[#F5F5F5] cursor-pointer`}
                          >
                            {option.label}
                          </div>
                        ))}
                      </div>
                    )}
                  </div>
                </div>

                <div className="mb-4 !text-left">
                  <div className="flex justify-between ps-2 pe-4 py-3 rounded-md border !border-[#d9d9d9]">
                    <div>Business Type</div>
                    <div className="flex gap-10">
                      <div>
                        <input
                          type="radio"
                          name={"business_type"}
                          id="B2B"
                          onChange={() =>
                            setInputs({ ...inputs, business_type: "B2B" })
                          }
                        />
                        <label htmlFor="B2B" className="ml-3">
                          B2B
                        </label>
                      </div>
                      <div>
                        <input
                          type="radio"
                          name={"business_type"}
                          id="B2C"
                          onChange={() =>
                            setInputs({ ...inputs, business_type: "B2C" })
                          }
                        />
                        <label htmlFor="B2C" className="ml-3">
                          B2C
                        </label>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="mb-4 !text-left">
                  <div className="relative w-full">
                    <div
                      onClick={() => setIsOpenCustomer(!isOpenCustomer)}
                      className="border !border-[#D9D9D9] px-2 py-[12px] rounded-md bg-white cursor-pointer"
                    >
                      {inputs.customer_size ||
                        "How many customers do you currently serve?"}
                    </div>
                    {isOpenCustomer && (
                      <div className="absolute z-10 mt-1 w-full bg-white border !border-[#D9D9D9] rounded-md shadow-md">
                        {optionsCustomer.map((option, index) => (
                          <div
                            key={index}
                            onClick={() => {
                              setInputs({
                                ...inputs,
                                customer_size: option.value,
                              });
                              setIsOpenCustomer(false);
                            }}
                            className={` ${inputs.team_size === option.value &&
                              "bg-[#F5F5F5]"
                              } px-4 py-2 hover:bg-[#F5F5F5] cursor-pointer`}
                          >
                            {option.label}
                          </div>
                        ))}
                      </div>
                    )}
                  </div>
                </div>
                <button
                  style={{
                    width: "100%",
                    padding: "12px",
                    borderRadius: "5px",
                  }}
                  size="large"
                  type="submit"
                  disabled={
                    loading ||
                    !inputs.business_name ||
                    !inputs.team_size ||
                    !inputs.customer_size ||
                    !inputs.business_type
                  }
                  className={`${loading ||
                    !inputs.business_name ||
                    !inputs.team_size ||
                    !inputs.customer_size ||
                    !inputs.business_type
                    ? "!bg-[#F5F5F5] border !border-[#D9D9D9] !text-black"
                    : "bg-black text-white"
                    }`}
                >
                  {loading ? "Loading..." : "Start Training Your AI"}
                </button>
                <span onClick={onBack ? onBack : () => navigate(-1)} className='text-[#757575] text-[12px] flex justify-start mt-8 cursor-pointer'>
                  ← Go back
                </span>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BusinessDetails;
